import http from './axios';
// import {StringFormat} from '@/libs/util'

export interface DatasourceDto {
  id?: number;
  // 数据源目录
  dsCategoryId?: number;
  dsCategoryName?: string;
  // 数据源大分类
  dsCategory?: string;
  // 名称
  dsName?: string;
  // 代码
  dsCode?: string;
  // 分类
  dsType: string;
  // 排序
  dsSort?: number;
  // 标签
  dsTag?: string;
  // 描述
  dsDescription?: string;
  // 使用状态，0-启用，1-禁用
  status?: number;
  // 审批状态
  approveStatus?: number;
  //项目
  projectId?: number;
  //jdbc 配置
  dsConfig: JdbcConfig;
  fileConfig: FileConfig;
  ossConfig: StorageConfig;
  hiveConf: HiveConf;
  esConf: EsConf;
  kafkaConf: KafkaConf;
  kafkaConfDto: KafkaConfig;
  restConfig: HttpRestConfig;
  dorisConf: DorisConf;
  columnConfig: [];
}
export interface JdbcConfig {
  //是否SSL
  useSSL?: number;
  //数据库地址
  ipAddr?: string;
  //数据库端口
  port?: string;
  //数据库实例
  dbInstance?: string;
  //URL
  url?: string;
  //用户名
  username?: string;
  //密码
  password?: string;
  //DBname
  dbName?: string;
  //连接串属性
  propsInput?: string;
  properties?: Array<any>;
}
export interface FileConfig {
  filePosition?: string;
  fileSource?: string;
  frequency?: string;
  fileExtension?: string;
  encoding?: string;
  //忽略首行
  ignoreFirstLine?: boolean;
  delimiter?: string;
  //日期区分
  dateSort?: string;
}
export interface StorageConfig {
  endpoint?: string;
  accessKeyId?: string;
  accessKeySecret?: string;
  bucketName?: string;
  serverUrl?: string;
}
export interface HttpRestConfig {
  protocol?: string;
  url?: string;
  // post/get
  requestMode?: string;
  fieldDelimiter?: string;
  // response text/json
  decode?: string;
  //decode为json时，指定解析的key
  fields?: string;
  // decode为json时，指定解析key的类型
  fieldTypes?: string;
  //请求的间隔时间 单位毫秒
  intervalTime?: number;
}
export interface EsConf {
  hostsInput?: string;
  hosts?: string[];
  clusterName?: string;
  index?: string;
  type?: string;
  // is open basic auth.
  authMesh?: boolean;
  username?: string;
  password?: string;
  // http or https
  scheme?: string;
}
export interface HiveConf {
  defaultFS?: string;
  fileType?: string;
  filePath?: string;
  fileName?: string;
  fieldDelimiter?: string;
  jdbcUrl?: string;
  username?: string;
  password?: string;
  partition?: string;
  partitionType?: string;
  schema?: string;
  tableName?: string;
  //串属性
  hadoopInput?: string;
  hadoopConfig?: any;
}
export interface KafkaConf {
  bootstrapServers?: Array<string>;
  clientId?: string;
  consumer?: KafkaConsumer;
  producer?: KafkaProduct;
  //串属性
  propsInput?: string;
  properties?: Array<any>;
  schema?: KafkaSchema;
}
export interface KafkaSchema {
  url?: string;
}
export interface KafkaConfig {
  bootstrapServers?: string;
  groupId?: string;
  autoOffsetReset?: string;
  topic?: string;
  securityProtocol?: string;
  // securityProtocol = SSL 
  sslKeyPassword?: string;
  sslKeystoreLocation?: string;
  sslKeystorePassword?: string;
  sslKeystoreBase64?: string;
  sslTruststorePassword?: string;
  sslTruststoreLocation?: string;
  sslTruststoreBase64?: string;
  // securityProtocol = SASL_PLAINTEXT PLAIN
  saslMechanism?: string;
  saslJaasConfig?: string;
  saslUerName?: string;
  saslPassword?: string;
  krbKeyTab?: string;
  krbKeyTabBase64?: string;
  krbPrincipal?: string;
  sslEndpointIdentificationAlgorithm?: string;
  schemaUrl?: string;
  // securityProtocol = SASL/GSSAPI (Kerberos)  GSSAPI
}
export interface KafkaConsumer {
  bootstrapServers?: string;
  groupId?: string;
  autoOffsetReset?: string;
  topic?: string;
  securityProtocol?: string;
  // securityProtocol = SSL 
  sslKeyPassword?: string;
  sslKeystoreLocation?: string;
  sslKeystorePassword?: string;
  sslKeystoreBase64?: string;
  sslTruststorePassword?: string;
  sslTruststoreLocation?: string;
  sslTruststoreBase64?: string;
  // securityProtocol = SASL_PLAINTEXT PLAIN
  saslMechanism?: string;
  saslJaasConfig?: string;
  saslUerName?: string;
  saslPassword?: string;
  krbKeyTab?: string;
  krbKeyTabBase64?: string;
  krbPrincipal?: string;
  sslEndpointIdentificationAlgorithm?: string;
  // securityProtocol = SASL/GSSAPI (Kerberos)  GSSAPI
}
export interface KafkaProduct {
  bootstrapServers?: string;
  topic?: string;
  acks?: string;
  securityProtocol?: string;
  // securityProtocol = SSL 
  sslKeyPassword?: string;
  sslKeystoreLocation?: string;
  sslKeystorePassword?: string;
  sslKeystoreBase64?: string;
  sslTruststorePassword?: string;
  sslTruststoreLocation?: string;
  sslTruststoreBase64?: string;
  // securityProtocol = SASL_PLAINTEXT PLAIN
  saslMechanism?: string;
  saslJaasConfig?: string;
  saslUerName?: string;
  saslPassword?: string;
  krbKeyTab?: string;
  krbKeyTabBase64?: string;
  krbPrincipal?: string;
  sslEndpointIdentificationAlgorithm?: string;
}
export interface DorisConf {
  //数据库地址
  ipAddr?: string;
  //数据库端口
  port?: string;
  //数据库实例
  dbInstance?: string;
  //FeNodes
  feNodesInput?: string;
  feNodes?: string[];
  //URL
  url?: string;
  //用户名
  username?: string;
  //密码
  password?: string;
  //是否SSL
  useSSL?: number;
  //DBname
  dbName?: string;
  //连接串属性
  propsInput?: string;
  properties?: Array<any>;
}

export interface ColumnConfig {
  id?: number;
  sourceId?: number;
  tableNameEn?: string;
  tableNameCn?: string;
  status?: number;
  inputFlag?: number;
  outputFlag?: number;
}

export default class DatasourceServices {
  private readonly category_api = '/v1/data/sources/category';
  private readonly tree_api = '/v1/data/sources/tree';
  private readonly list_api = '/v1/data/sources/';
  private readonly info_api = '/v1/data/sources';
  private readonly save_api = '/v1/data/sources/';
  private readonly update_api = '/v1/data/sources';
  private readonly remove_api = '/v1/data/sources/';
  private readonly test_api = '/v1/data/sources/test';
  // private readonly tables_api = 'v1/data/sources/tables';
  private readonly databases_api = 'v1/data/sources/databases';
  private readonly inittable_api = 'v1/data/sources/init';
  private readonly uploadKafkaSSLFile_api = 'v1/data/sources/upload_ssl'

  //tableConfig
  private readonly updateTable_api = 'v1/data/dstablecfg/';
  private readonly getTables_api = 'v1/data/dstablecfg/list';
  private readonly deleteTables_api = '/v1/data/dstablecfg/delete';
  private readonly saveTables_api = '/v1/data/dstablecfg/savelist';

  //columnConfig
  private readonly getColumns_api = 'v1/data/dscolcfg/list';
  private readonly deleteColumns_api = '/v1/data/dscolcfg/delete';
  private readonly updateColumn_api = 'v1/data/dscolcfg/';
  private readonly initColumn_api = 'v1/data/dscolcfg/init';
  private readonly saveColumns_api = 'v1/data/dscolcfg/savelist';
  private readonly uploadTemplate_api = 'v1/data/dscolcfg/uploadtemplate';

  //permissionCfg
  private readonly getPermissions_api = 'v1/data/dspermcfg/list';
  private readonly deletePermissions_api = '/v1/data/dspermcfg/delete';
  private readonly updatePermission_api = 'v1/data/dspermcfg/';
  private readonly savePermissions_api = 'v1/data/dspermcfg/savelist';

  constructor() {}

  /** 目录 */
  async getCategory(params?: object): Promise<any> {
    let res: any = await http.get(this.category_api, { params: params });
    return res.payload;
  }
  /**  主表单数据 */
  async getList(params?: object): Promise<any> {
    let res: any = await http.get(this.list_api, { params: params });
    return res.payload;
  }

  async getInfo(id: string | number) {
    let res: any = await http.get(this.info_api + '/' + id);
    let formData = this.transformData(res.payload);
    return formData;
  }

  async add(data: DatasourceDto) {
    let submitData = this.formatFormData(data);
    const params = { ...submitData, dsSort: '1', projectId: 1, dsCode: 'DS_' + data.dsCode };
    let res: any = await http.post(this.save_api, params);
    return res.header?.code == 200 ? res.payload : false;
  }

  async update(id: string | number, data: DatasourceDto): Promise<boolean> {
    let res: any = await http.put(this.update_api + '/' + id, this.formatFormData(data));
    return res.header?.code == 200;
  }

  async remove(id: string | number) {
    let res: any = await http.delete(this.remove_api + '/' + id);
    return res.header?.code == 200;
  }

  async test(data: DatasourceDto) {
    let submitData = this.formatFormData(data);
    let res: any = await http.post(this.test_api, submitData);
    return res.header?.code == 200;
  }
  async initTables(id: number) {
    let params = { id: id };
    let res: any = await http.post(this.inittable_api, null, { params: params, timeout: 30000 });
    return res.payload;
  }

  //提交数据格式化
  formatFormData(formData: DatasourceDto) {
    let submitData = { ...formData };
    let dsType = formData.dsType.toLowerCase();
    
    if (dsType === 'mysql' || dsType === 'oracle' || dsType === 'sqlserver' || dsType === 'postgresql' 
        || dsType === 'hana' || dsType === 'clickhouse') {
      submitData.dsConfig = { ...formData.dsConfig };
      let properties = formData.dsConfig.propsInput as string;
      let list = [];
      for (let item of properties.split('&')) {
        if (!item) continue;
        let itemArr = item.split('=');
        if (itemArr.length != 2) {
          //格式错误
        } else {
          list.push({ key: itemArr[0], value: itemArr[1] });
        }
      }
      submitData.dsConfig.properties = list;
    } else if (dsType === 'elasticsearch') {
      submitData.esConf = { ...formData.esConf};
      submitData.esConf.hosts = formData.esConf.hostsInput ? formData.esConf.hostsInput.split(',') : [];
      delete submitData.esConf.hostsInput;
    } else if (dsType === 'file') {
      submitData.fileConfig = formData.fileConfig;
    } else if (dsType === 'kafka') {
      submitData.kafkaConf = formData.kafkaConf;
    } else if (dsType === 'hive') {
      submitData.hiveConf = formData.hiveConf;
    } else if (dsType === 'doris') {
      submitData.dorisConf = { ...formData.dorisConf };
      let properties = formData.dorisConf.propsInput as string;
      let list = [];
      for (let item of properties.split('&')) {
        if (!item) continue;
        let itemArr = item.split('=');
        if (itemArr.length != 2) {
          //格式错误
        } else {
          list.push({ key: itemArr[0], value: itemArr[1] });
        }
      }
      submitData.dorisConf.properties = list;

      if (!formData.dorisConf.feNodesInput) {
        let feNodesInput = formData.dorisConf.feNodesInput as string;
        submitData.dorisConf.feNodes = feNodesInput.split('=');
      }
      
    }
    return submitData;
  }
  //显示数据格式化
  transformData(formData: DatasourceDto) {
    let res = '';
    if (formData.dsConfig != null && formData.dsConfig.properties != null) {
      for (let item of formData.dsConfig.properties) {
        res += '&' + item.key + '=' + item.value;
        res = res.substring(1);
      }
      formData.dsConfig.propsInput = res;
    }

    if (formData.esConf != null && formData.esConf.hosts != null) {
      formData.esConf.hostsInput = formData.esConf.hosts.join(',');
    }

    if (formData.dorisConf != null && formData.dorisConf.properties != null) {
      for (let item of formData.dorisConf.properties) {
        res += '&' + item.key + '=' + item.value;
        res = res.substring(1);
      }
      formData.dorisConf.propsInput = res;
    }
    if (formData.dorisConf != null && formData.dorisConf.feNodes != null) {
      for (let item of formData.dorisConf.feNodes) {
        res += item + ';';
        res = res.substring(1);
      }
      formData.dorisConf.feNodesInput = res;
    }

    return formData;
  }

  urlFormatEnum: any = {
    mysql: 'jdbc:mysql://{0}:{1}/{2}',
    oracle: 'jdbc:oracle://{0}:{1}/{2}',
    hive: 'jdbc:hive2://{0}:{1}/',
    Presto: 'jdbc:presto://{0}:{1}/{2}'
  };

  /**********table Config */
  async tables(params?: object) {
    let res: any = await http.get(this.getTables_api, { params: params });
    return res.payload;
  }

  async deleteTables(ids: number[]) {
    let res: any = await http.post(this.deleteTables_api, ids);
    return res.header?.code == 200;
  }
  async updateTable(data: any) {
    let res: any = await http.put(this.updateTable_api, data);
    return res.header.code == 200;
  }
  async saveTables(data: any[]) {
    let res: any = await http.post(this.saveTables_api, data);
    return res.header.code == 200;
  }
  /***********Column Config */
  async columns(params?: object) {
    let res: any = await http.get(this.getColumns_api, { params: params });
    return res.payload;
  }
  async initColumns(params?: object) {
    let res: any = await http.get(this.initColumn_api, { params: params });
    return res.payload;
  }
  async deleteColumns(ids: number[]) {
    let res: any = await http.post(this.deleteColumns_api, ids);
    return res.header?.code == 200;
  }
  async updateColumn(cfg: any) {
    let res: any = await http.put(this.updateColumn_api, cfg);
    return res.header.code == 200;
  }
  async saveColumns(cfgs: any[]) {
    let res: any = await http.post(this.saveColumns_api, cfgs);
    return res.header.code == 200;
  }
  async uploadTemplate(data: any) {
    let res: any = await http.post(this.uploadTemplate_api, data);
    return res.payload;
  }
  async uploadKafkaSSLFile(data: any) {
    let res: any = await http.post(this.uploadKafkaSSLFile_api, data);
    return res.payload;
  }
  /***********Permission Config */
  async permissions(params?: object) {
    let res: any = await http.get(this.getPermissions_api, { params: params });
    return res.payload;
  }

  async deletePermissions(ids: number[]) {
    let res: any = await http.post(this.deletePermissions_api, ids);
    return res.header?.code == 200;
  }
  async updatePermission(cfg: any) {
    let res: any = await http.put(this.updatePermission_api, cfg);
    return res.header.code == 200;
  }
  async savePermissions(cfgs: any[]) {
    let res: any = await http.post(this.savePermissions_api, cfgs);
    return res.header.code == 200;
  }

  async databases(data: DatasourceDto) {
    if (data.dsType === 'mysql' && !data.dsConfig.dbName) {
      data.dsConfig.dbName = data.dsConfig.dbInstance;
    }
    let res: any = await http.post(this.databases_api, data);
    return res.payload;
  }
}
